import { render, staticRenderFns } from "./lk-lead-list-item.vue?vue&type=template&id=53f1c840&"
import script from "./lk-lead-list-item.vue?vue&type=script&lang=js&"
export * from "./lk-lead-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-leads-list/lk-lead-list-item.vue
// module id = 1167
// module chunks = 0